import { FC } from 'react';

import useTrls from 'hooks/translation/useTrls';

import { CardCommonContent } from 'components/CpcFlexibleCreate/SourcesAndBudgetsSidebar/CardCommonContent/CardCommonContent';

const TrlKeys = {
    title: 'AdCreate.AdForm.AdSources.SourceDisableCard.NewSourcesNotAllowedCard.title',
    text: 'AdCreate.AdForm.AdSources.SourceDisableCard.NewSourcesNotAllowedCard.text',
};

export const NewSourcesNotAllowedCard: FC = () => {
    const trls = useTrls();

    return <CardCommonContent title={trls(TrlKeys.title)} text={trls(TrlKeys.text)} style="negative-secondary" />;
};
